import { START_YEAR as b } from "./ghl-ui.es1279.js";
import O from "./ghl-ui.es1280.js";
import D from "./ghl-ui.es936.js";
import y from "./ghl-ui.es935.js";
import p from "./ghl-ui.es1281.js";
import c from "./ghl-ui.es937.js";
import Y from "./ghl-ui.es1282.js";
import h from "./ghl-ui.es1283.js";
import j from "./ghl-ui.es1284.js";
import w from "./ghl-ui.es1285.js";
import N from "./ghl-ui.es1286.js";
import Q from "./ghl-ui.es1287.js";
import R from "./ghl-ui.es1288.js";
import M from "./ghl-ui.es1289.js";
import m from "./ghl-ui.es1290.js";
import S from "./ghl-ui.es1291.js";
import k from "./ghl-ui.es1292.js";
import U from "./ghl-ui.es1293.js";
import C from "./ghl-ui.es1294.js";
import q from "./ghl-ui.es1295.js";
import x from "./ghl-ui.es1296.js";
const F = {
  date: q,
  month: S,
  year: k,
  quarter: C
};
function E(t) {
  return (e, r) => {
    const n = (t + 1) % 7;
    return x(e, r, {
      weekStartsOn: n
    });
  };
}
function i(t, e, r, n = 0) {
  return (r === "week" ? E(n) : F[r])(t, e);
}
function g(t, e, r, n, o, a) {
  return o === "date" ? L(t, e, r, n) : P(t, e, r, n, a);
}
function L(t, e, r, n) {
  let o = !1, a = !1, f = !1;
  Array.isArray(r) && (r[0] < t && t < r[1] && (o = !0), i(r[0], t, "date") && (a = !0), i(r[1], t, "date") && (f = !0));
  const s = r !== null && (Array.isArray(r) ? i(r[0], t, "date") || i(r[1], t, "date") : i(r, t, "date"));
  return {
    type: "date",
    dateObject: {
      date: M(t),
      month: p(t),
      year: m(t)
    },
    inCurrentMonth: S(t, e),
    isCurrentDate: i(n, t, "date"),
    inSpan: o,
    inSelectedWeek: !1,
    startOfSpan: a,
    endOfSpan: f,
    selected: s,
    ts: c(t)
  };
}
function dt(t, e, r) {
  const n = Date.UTC(2e3, t, 1);
  return y(n, e, {
    locale: r
  });
}
function st(t, e, r) {
  const n = Date.UTC(t, 1, 1);
  return y(n, e, {
    locale: r
  });
}
function pt(t, e, r) {
  const n = Date.UTC(2e3, t * 3 - 2, 1);
  return y(n, e, {
    locale: r
  });
}
function P(t, e, r, n, o) {
  let a = !1, f = !1, s = !1;
  Array.isArray(r) && (r[0] < t && t < r[1] && (a = !0), i(r[0], t, "week", o) && (f = !0), i(r[1], t, "week", o) && (s = !0));
  const u = r !== null && (Array.isArray(r) ? i(r[0], t, "week", o) || i(r[1], t, "week", o) : i(r, t, "week", o));
  return {
    type: "date",
    dateObject: {
      date: M(t),
      month: p(t),
      year: m(t)
    },
    inCurrentMonth: S(t, e),
    isCurrentDate: i(n, t, "date"),
    inSpan: a,
    startOfSpan: f,
    endOfSpan: s,
    selected: !1,
    inSelectedWeek: u,
    ts: c(t)
  };
}
function W(t, e, r, {
  monthFormat: n
}) {
  return {
    type: "month",
    monthFormat: n,
    dateObject: {
      month: p(t),
      year: m(t)
    },
    isCurrent: S(r, t),
    selected: e !== null && i(e, t, "month"),
    ts: c(t)
  };
}
function _(t, e, r, {
  yearFormat: n
}) {
  return {
    type: "year",
    yearFormat: n,
    dateObject: {
      year: m(t)
    },
    isCurrent: k(r, t),
    selected: e !== null && i(e, t, "year"),
    ts: c(t)
  };
}
function z(t, e, r, {
  quarterFormat: n
}) {
  return {
    type: "quarter",
    quarterFormat: n,
    dateObject: {
      quarter: U(t),
      year: m(t)
    },
    isCurrent: C(r, t),
    selected: e !== null && i(e, t, "quarter"),
    ts: c(t)
  };
}
function mt(t, e, r, n, o = !1, a = !1) {
  const f = a ? "week" : "date", s = p(t);
  let u = c(Y(t)), l = c(h(u, -1));
  const d = [];
  let A = !o;
  for (; j(l) !== n || A; )
    d.unshift(g(l, t, e, r, f, n)), l = c(h(l, -1)), A = !1;
  for (; p(u) === s; )
    d.push(g(u, t, e, r, f, n)), u = c(h(u, 1));
  const I = o ? d.length <= 28 ? 28 : d.length <= 35 ? 35 : 42 : 42;
  for (; d.length < I; )
    d.push(g(u, t, e, r, f, n)), u = c(h(u, 1));
  return d;
}
function lt(t, e, r, n) {
  const o = [], a = w(t);
  for (let f = 0; f < 12; f++)
    o.push(W(c(N(a, f)), e, r, n));
  return o;
}
function ht(t, e, r, n) {
  const o = [], a = w(t);
  for (let f = 0; f < 4; f++)
    o.push(z(c(Q(a, f)), e, r, n));
  return o;
}
function yt(t, e, r) {
  const n = [], o = new Date(b, 0, 1);
  for (let a = 0; a < 200; a++)
    n.push(_(c(R(o, a)), t, e, r));
  return n;
}
function St(t, e, r, n) {
  const o = O(t, e, r, n);
  return D(o) ? y(o, e, n) === t ? o : /* @__PURE__ */ new Date(NaN) : o;
}
function gt(t) {
  if (t === void 0)
    return;
  if (typeof t == "number")
    return t;
  const [e, r, n] = t.split(":");
  return {
    hours: Number(e),
    minutes: Number(r),
    seconds: Number(n)
  };
}
function At(t, e) {
  return Array.isArray(t) ? t[e === "start" ? 0 : 1] : null;
}
export {
  mt as dateArray,
  gt as getDefaultTime,
  dt as getMonthString,
  pt as getQuarterString,
  st as getYearString,
  lt as monthArray,
  At as pluckValueFromRange,
  ht as quarterArray,
  St as strictParse,
  yt as yearArray
};
